module.exports = __webpack_public_path__ + "img/14@3x.4f9c36d9.png";